import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  FaHome,
  FaUsers,
  FaBullhorn,
  FaLightbulb,
  FaBriefcase,
  FaComment,
  FaDollarSign,
} from 'react-icons/fa';

const tabs = [
  { icon: <FaHome className="text-xl" />, label: 'Overview', path: '/dashboard' },
  { icon: <FaUsers className="text-xl" />, label: 'Users', path: '/users' },
  { icon: <FaBullhorn className="text-xl" />, label: 'Campaigns', path: '/campaigns' },
  { icon: <FaLightbulb className="text-xl" />, label: 'Takeovers', path: '/takeovers' },
  { icon: <FaBriefcase className="text-xl" />, label: 'Creatives', path: '/creatives' },
  { icon: <FaDollarSign className="text-xl" />, label: 'Finances', path: '/finances' },
  { icon: <FaComment className="text-xl" />, label: 'iMessage', path: '/imessage' },
];

const MobileTabBar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-[2000] flex h-[62px] items-stretch justify-around border-t border-slate-200/90 bg-white/90 pb-[env(safe-area-inset-bottom,0px)] shadow-[0_-8px_24px_rgba(15,23,42,0.08)] backdrop-blur-md md:hidden max-[390px]:h-[54px]"
      aria-label="Primary"
    >
      {tabs.map((tab) => {
        const active =
          tab.path === '/dashboard'
            ? location.pathname === '/' ||
              location.pathname === '/dashboard' ||
              location.pathname.startsWith('/dashboard/')
            : location.pathname === tab.path || location.pathname.startsWith(`${tab.path}/`);
        return (
          <button
            key={tab.path}
            type="button"
            className={[
              'relative flex min-w-0 flex-1 flex-col items-center justify-center gap-0.5 px-1 text-[0.85rem] font-medium transition-colors',
              active ? 'font-semibold text-primary' : 'text-slate-500 hover:text-slate-800',
              'max-[390px]:justify-center max-[390px]:text-[0.7rem]',
            ].join(' ')}
            onClick={() => navigate(tab.path)}
            aria-label={tab.label}
          >
            <span className="mb-0.5 flex max-[390px]:mb-0">{tab.icon}</span>
            <span className="block max-w-full truncate max-[390px]:hidden">{tab.label}</span>
            {active && (
              <span className="absolute bottom-1.5 h-1 w-6 rounded-full bg-primary max-[390px]:bottom-2" />
            )}
          </button>
        );
      })}
    </nav>
  );
};

export default MobileTabBar;
